/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S10_BodyInputs */

const en_fc_tut_s10_body = /** @type {(inputs: Fc_Tut_S10_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to Export, choose H.264 MP4 for the web or ProRes 422 HQ for a high-quality master, set the range and destination, and render. Rendering runs in the background, so you can keep editing.`)
};

/**
* | output |
* | --- |
* | "Switch to Export, choose H.264 MP4 for the web or ProRes 422 HQ for a high-quality master, set the range and destination, and render. Rendering runs in the b..." |
*
* @param {Fc_Tut_S10_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s10_body = /** @type {((inputs?: Fc_Tut_S10_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S10_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s10_body(inputs)
});
export { fc_tut_s10_body as "fc.tut.s10.body" }